import React from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import { FaFileDownload } from "react-icons/fa";
import { CiRedo } from "react-icons/ci";

export default function PaymentFail() {
  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />

      <main className="flex-1 min-w-0  p-6">
        <LeftResponsivesidebar />
        <Headmenu />
        <div className=" mx-auto p-6 bg-white rounded-xl shadow-lg">
          <div className="flex flex-col items-center mb-6">
            <div className=" rounded-full p-4 mb-3">
              <img
                src="/image/fail.png"
                className="w-[100px] h=[100px]"
                alt=""
              />
            </div>
            <h2 className="text-lg font-semibold mb-1 text-[#BE1F2E]">
              Payment Failed
            </h2>
            <p className="text-gray-500 mb-4 text-center">
              Unfortunately, we couldn’t process your payment.
            </p>
            <div className="text-center mb-2">
              <div className="text-gray-500 text-xs">Total Payment</div>
              <div className="text-2xl font-bold">IDR 1,000,000</div>
              <div className="text-xs text-gray-400">25 Feb 2023, 13:22</div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-6">
            <div className="border p-2 space-y-1 rounded-md">
              <div className="text-xs text-gray-500">Order No</div>
              <div className="font-medium">125686246</div>
            </div>
            <div className="border p-2 space-y-1 rounded-md">
              <div className="text-xs text-gray-500">Payment Ref No.</div>
              <div className="font-medium text-[#BE1F2E]">Failed</div>
            </div>
            <div className="border p-2 space-y-1 rounded-md">
              <div className="text-xs text-gray-500">Sender Name</div>
              <div className="font-medium">Antonio Roberto</div>
            </div>
            <div className="border p-2 space-y-1 rounded-md">
              <div className="text-xs text-gray-500">Payment Method</div>
              <div className="font-medium">Credit Card (**** 4532)</div>
            </div>
          </div>

          <div className="mb-4 border p-2 space-y-1 rounded-md">
            <div className="text-xs text-gray-500 mb-1">Shipping Details</div>
            <div className="font-medium">
              Flat No 256, 22nd Floor, 5 Th Cross Street, Chennai – 600 023 |
              Phone No: +91 7904330323
            </div>
          </div>
          <div className="w-full flex justify-center">
            <button className="flex gap-3 rounded-full items-center justify-center bg-[#BE1F2E]  text-white px-4 py-2 mb-6">
              <CiRedo className="text-xl bg-white text-red-700 font-bold rounded-md" />
              Get PDF Receipt
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
